import React from 'react';

// Components
import IntegrationPageHeader from './partials/IntegrationPageHeader';
import SecondaryHeader from '@/views/components/layout/SecondaryHeader';

// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import LoadingScreen from '../../components/common/LoadingScreen';

type Props = {
  children: React.ReactNode;
  FooterComponent?: React.ReactNode;
  i18nBasePath: string;
  isLoading?: boolean;
  LoaderComponent?: React.ElementType<{}>;
  mainClassName: string;
  onClose: () => void;
  hideTitleAndInstructions?: boolean;
};

const ConquestIntegrationLayout: React.FC<Props> = (props: Props) => {
  const { children, FooterComponent, i18nBasePath, isLoading, LoaderComponent, mainClassName, onClose, hideTitleAndInstructions } = props;

  const renderLoaderContent = () => (
    <div className="page-body">
      <div className="page-content">
        <IntegrationPageHeader />
        {LoaderComponent ? <LoaderComponent /> : <LoadingScreen />}
      </div>
    </div>
  );

  const renderContent = () => (
    <>
      <SecondaryHeader
        onBack={onClose}
        titleElement={<FormattedMessage id={`${i18nBasePath}.Header`} />}
        buttonTextToLocalized="Common.Close"
        buttonAriaLabel={formatMessage('Common.Close')}
      />
      <div className="page-body">
        <div className="page-content">
          <IntegrationPageHeader
            title={hideTitleAndInstructions ? '' : formatMessage(`${i18nBasePath}.PageTitle`)}
            instructions={hideTitleAndInstructions ? '' : formatMessage(`${i18nBasePath}.Instructions`)}
            hideText={hideTitleAndInstructions}
          />
          {children}
        </div>
      </div>
      <footer>
        <div className="footer-content">{FooterComponent}</div>
      </footer>
    </>
  );

  return (
    <main id="content" className={`${mainClassName} conquest-integration-layout`}>
      {isLoading ? renderLoaderContent() : renderContent()}
    </main>
  );
};

export default ConquestIntegrationLayout;
